import {SET_DOCUMENTS_META, SET_PRECONTRACTS_META} from "../actions/constants";
import {createReducer} from "../../../_common/common";


export const exemption_100 = createReducer({state: null, proto_meta: [], documents_meta: []}, {
    [SET_PRECONTRACTS_META]: (state, { proto_meta }) => {
        state.proto_meta = proto_meta;
        return state;
    },
    [SET_DOCUMENTS_META]: (state, { documents_meta }) => {
        state.documents_meta = documents_meta;
        return state;
    }
});
